export class Config {
    public static PublicFaceScanEncryptionKey: string =
        "-----BEGIN PUBLIC KEY-----\n" +
        "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA5PxZ3DLj+zP6T6HFgzzk\n" +
        "M77LdzP3fojBoLasw7EfzvLMnJNUlyRb5m8e5QyyJxI+wRjsALHvFgLzGwxM8ehz\n" +
        "DqqBZed+f4w33GgQXFZOS4AOvyPbALgCYoLehigLAbbCNTkeY5RDcmmSI/sbp+s6\n" +
        "mAiAKKvCdIqe17bltZ/rfEoL3gPKEfLXeN549LTj3XBp0hvG4loQ6eC1E1tRzSkf\n" +
        "GJD4GIVvR+j12gXAaftj3ahfYxioBH7F7HQxzmWkwDyn3bqU54eaiB7f0ftsPpWM\n" +
        "ceUaqkL2DZUvgN0efEJjnWy5y1/Gkq5GGWCROI9XG/SwXJ30BbVUehTbVcD70+ZF\n" +
        "8QIDAQAB\n" +
        "-----END PUBLIC KEY-----"    
        ;
    public static BaseURL: string = "https://api-dev.envoc.com/facelock-match";
    public static LicenseText: string = "# UR Scan Match SDK License \n" +
"appId       = com.envoc.*,id.facelock.*" + "\n" +
"domains       = envoc.com,envoc.live,facelock.id" + "\n" +
"signature   = 00304402203c97209dbc2fec12cfc19a8c1555f09d4d0bb22e2442acc00e03a68162832a600220426e39f6d51304773b610bd3d92e987daf3539854c615c65390e2c9d386624aa5b44651ff7db9a686f2e753a3d3cbe21b0eb09d31a27de378d8cb34cc3bb1e6c";


    public static LicenseTexthold: string = "# UR Scan Match SDK License \n" +
"appId       = com.envoc.*,id.facelock.*\n" +
"domains     = envoc.com,envoc.live,facelock.id\n" +
"signature   = 00304402203c97209dbc2fec12cfc19a8c1555f09d4d0bb22e2442acc00e03a68162832a600220426e39f6d51304773b610bd3d92e987daf3539854c615c65390e2c9d386624aa5b44651ff7db9a686f2e753a3d3cbe21b0eb09d31a27de378d8cb34cc3bb1e6c";

    public static BuildVersion: string = "v2.7"; // Increment this for each deployment
}